/**
 * @fileoverview POST handler for the "/companies/:company_id/security_settings/security_event_config_test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSecuritySettingsSecurityEventConfigTestCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdSecuritySettingsSecurityEventConfigTestProps,
  CompanySecurityEventConfigTestResult,
} from "./types";

export const postCompanySecurityEventConfigTest = reactQueryMutationAdapter(
  companiesCompanyIdSecuritySettingsSecurityEventConfigTestCacheKeys,
  ([props]: readonly [
    PostCompaniesCompanyIdSecuritySettingsSecurityEventConfigTestProps,
  ]): Promise<CompanySecurityEventConfigTestResult> => {
    return fetch(
      `/companies/${encodeURIComponent(props.company_id)}/security_settings/security_event_config_test`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
